/* eslint-disable react/prop-types */
import React from "react";

const DashboardSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1667 21.5V9.83333H21.5V21.5H12.1667ZM0.5 12.1667V0.5H9.83333V12.1667H0.5ZM7.5 9.83333V2.83333H2.83333V9.83333H7.5ZM0.5 21.5V14.5H9.83333V21.5H0.5ZM2.83333 19.1667H7.5V16.8333H2.83333V19.1667ZM14.5 19.1667H19.1667V12.1667H14.5V19.1667ZM12.1667 0.5H21.5V7.5H12.1667V0.5ZM14.5 2.83333V5.16667H19.1667V2.83333H14.5Z"
        fill={fill}
      />
    </svg>
  );
};

const BalanceSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 8.16667H24.5C24.8094 8.16667 25.1061 8.28958 25.3249 8.50838C25.5437 8.72717 25.6666 9.02391 25.6666 9.33333V23.3333C25.6666 23.6428 25.5437 23.9395 25.3249 24.1583C25.1061 24.3771 24.8094 24.5 24.5 24.5H3.49998C3.19056 24.5 2.89381 24.3771 2.67502 24.1583C2.45623 23.9395 2.33331 23.6428 2.33331 23.3333V4.66667C2.33331 4.35725 2.45623 4.0605 2.67502 3.84171C2.89381 3.62292 3.19056 3.5 3.49998 3.5H21V8.16667ZM4.66665 10.5V22.1667H23.3333V10.5H4.66665ZM4.66665 5.83333V8.16667H18.6666V5.83333H4.66665ZM17.5 15.1667H21V17.5H17.5V15.1667Z"
        fill={fill}
      />
    </svg>
  );
};

const TransactionSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_222)">
        <path
          d="M14 25.6667C7.55648 25.6667 2.33331 20.4435 2.33331 14C2.33331 7.5565 7.55648 2.33333 14 2.33333C20.4435 2.33333 25.6666 7.5565 25.6666 14C25.6666 20.4435 20.4435 25.6667 14 25.6667ZM14 23.3333C16.4753 23.3333 18.8493 22.35 20.5996 20.5997C22.35 18.8493 23.3333 16.4753 23.3333 14C23.3333 11.5246 22.35 9.15067 20.5996 7.40033C18.8493 5.64999 16.4753 4.66666 14 4.66666C11.5246 4.66666 9.15066 5.64999 7.40032 7.40033C5.64998 9.15067 4.66665 11.5246 4.66665 14C4.66665 16.4753 5.64998 18.8493 7.40032 20.5997C9.15066 22.35 11.5246 23.3333 14 23.3333ZM8.16665 15.1667H18.6666V17.5H14V21L8.16665 15.1667ZM14 10.5V6.99999L19.8333 12.8333H9.33331V10.5H14Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3_222">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ProductSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3333 25.6667H4.66667C4.35725 25.6667 4.0605 25.5437 3.84171 25.325C3.62292 25.1062 3.5 24.8094 3.5 24.5V3.49999C3.5 3.19058 3.62292 2.89383 3.84171 2.67504C4.0605 2.45624 4.35725 2.33333 4.66667 2.33333H23.3333C23.6428 2.33333 23.9395 2.45624 24.1583 2.67504C24.3771 2.89383 24.5 3.19058 24.5 3.49999V24.5C24.5 24.8094 24.3771 25.1062 24.1583 25.325C23.9395 25.5437 23.6428 25.6667 23.3333 25.6667ZM22.1667 23.3333V4.66666H5.83333V23.3333H22.1667ZM10.5 6.99999V9.33333C10.5 10.2616 10.8687 11.1518 11.5251 11.8082C12.1815 12.4646 13.0717 12.8333 14 12.8333C14.9283 12.8333 15.8185 12.4646 16.4749 11.8082C17.1313 11.1518 17.5 10.2616 17.5 9.33333V6.99999H19.8333V9.33333C19.8333 10.8804 19.2188 12.3642 18.1248 13.4581C17.0308 14.5521 15.5471 15.1667 14 15.1667C12.4529 15.1667 10.9692 14.5521 9.87521 13.4581C8.78125 12.3642 8.16667 10.8804 8.16667 9.33333V6.99999H10.5Z"
        fill={fill}
      />
    </svg>
  );
};

const ArrowSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.99999 2.828L2.04999 7.778L0.635986 6.364L6.99999 0L13.364 6.364L11.95 7.778L6.99999 2.828Z"
        fill={fill}
      />
    </svg>
  );
};

const ArrowDownSVG = ({ height = 21, width = 21, fill = "#212121" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_762)">
        <path
          d="M14 15.3673L19.775 9.59235L21.4247 11.242L14 18.6667L6.57532 11.242L8.22498 9.59235L14 15.3673Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_762">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ChannelSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_233)">
        <path
          d="M17.5 3.5C18.144 3.5 18.6667 4.02267 18.6667 4.66667V9.33333C18.6667 9.97733 18.144 10.5 17.5 10.5H15.1667V12.8333H19.8333C20.4773 12.8333 21 13.356 21 14V17.5H23.3333C23.9773 17.5 24.5 18.0227 24.5 18.6667V23.3333C24.5 23.9773 23.9773 24.5 23.3333 24.5H16.3333C15.6893 24.5 15.1667 23.9773 15.1667 23.3333V18.6667C15.1667 18.0227 15.6893 17.5 16.3333 17.5H18.6667V15.1667H9.33333V17.5H11.6667C12.3107 17.5 12.8333 18.0227 12.8333 18.6667V23.3333C12.8333 23.9773 12.3107 24.5 11.6667 24.5H4.66667C4.02267 24.5 3.5 23.9773 3.5 23.3333V18.6667C3.5 18.0227 4.02267 17.5 4.66667 17.5H7V14C7 13.356 7.52267 12.8333 8.16667 12.8333H12.8333V10.5H10.5C9.856 10.5 9.33333 9.97733 9.33333 9.33333V4.66667C9.33333 4.02267 9.856 3.5 10.5 3.5H17.5ZM10.5 19.8333H5.83333V22.1667H10.5V19.8333ZM22.1667 19.8333H17.5V22.1667H22.1667V19.8333ZM16.3333 5.83333H11.6667V8.16667H16.3333V5.83333Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3_233">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const LogoutSVG = ({ height = 21, width = 21, fill = "#7A7A7A" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_258)">
        <path
          d="M5.83335 25.6667C5.52393 25.6667 5.22719 25.5437 5.0084 25.325C4.7896 25.1062 4.66669 24.8094 4.66669 24.5V3.49999C4.66669 3.19058 4.7896 2.89383 5.0084 2.67504C5.22719 2.45624 5.52393 2.33333 5.83335 2.33333H22.1667C22.4761 2.33333 22.7729 2.45624 22.9916 2.67504C23.2104 2.89383 23.3334 3.19058 23.3334 3.49999V6.99999H21V4.66666H7.00002V23.3333H21V21H23.3334V24.5C23.3334 24.8094 23.2104 25.1062 22.9916 25.325C22.7729 25.5437 22.4761 25.6667 22.1667 25.6667H5.83335ZM21 18.6667V15.1667H12.8334V12.8333H21V9.33333L26.8334 14L21 18.6667Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3_258">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const MoretwolineSVG = ({ height = 21, width = 21, fill = "#212121" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_772)">
        <path
          d="M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_772">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ArrowrightdownSVG = ({ height = 21, width = 21, fill = "#E94948" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_821)">
        <path
          d="M14.59 16.004L5.98199 7.397L7.39599 5.983L16.003 14.589V7.004H18.003V18.004H7.00299V16.004H14.59Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_821">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ArrowrightupSVG = ({ height = 21, width = 21, fill = "#36D189" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_830)">
        <path
          d="M16.004 9.414L7.397 18.021L5.983 16.607L14.589 8H7.004V6H18.004V17H16.004V9.414V9.414Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_830">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ArrowrightSVG = ({ height = 21, width = 21, fill = "#FFDC7D" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.172 11L10.808 5.63598L12.222 4.22198L20 12L12.222 19.778L10.808 18.364L16.172 13H4V11H16.172Z"
        fill={fill}
      />
    </svg>
  );
};

export {
  DashboardSVG,
  BalanceSVG,
  TransactionSVG,
  ProductSVG,
  ChannelSVG,
  ArrowDownSVG,
  ArrowSVG,
  LogoutSVG,
  MoretwolineSVG,
  ArrowrightdownSVG,
  ArrowrightupSVG,
  ArrowrightSVG,
};
